import {
  CarrierVisitDirection,
  NonNumericOrderDto,
  OrderResponseDto,
  PickUpOrderFilterType,
} from '@planning/app/api'
import { SimpleListStore } from '@planning/components/list/SimpleListStore'
import { TenantStore } from '@planning/rt-stores/tenant/TenantStore'
import { nnrOrderService, orderService } from '@planning/services'
import generalCargoService from '@planning/services/generalCargoService'
import { computed, makeObservable } from 'mobx'

export class PickUpOrderSearchStore extends SimpleListStore<OrderResponseDto | NonNumericOrderDto> {
  constructor(private tenantStore: TenantStore) {
    super(async (filter: string) => {
      const orders = await orderService.pickUpOrders(filter, PickUpOrderFilterType.ContainerNumber)
      const nnrOrders = await nnrOrderService.getByReferenceNumber(filter)

      let generalCargoOrders: OrderResponseDto[] = []
      if (this.tenantStore.hasGeneralCargo) {
        generalCargoOrders = await generalCargoService.getByCustomerOrReferenceNumber(
          filter,
          CarrierVisitDirection.Outbound,
        )
      }

      const list = [...orders, ...nnrOrders, ...generalCargoOrders]

      return list
    })
    makeObservable(this, {
      orders: computed,
      nnrOrders: computed,
    })
  }

  private isNonNumericOrder = (item: OrderResponseDto | NonNumericOrderDto) => 'amount' in item

  get orders() {
    return this.items.filter(o => !this.isNonNumericOrder(o)).map(o => o as OrderResponseDto)
  }

  get nnrOrders() {
    return this.items.filter(this.isNonNumericOrder).map(o => o as NonNumericOrderDto)
  }
}
